import {
  FETCH_WORKOUT_COPY_SUCCESS,
  FETCH_WORKOUT_COPY_ERROR,
  FETCH_WORKOUT_COPY_LOADING,
  CREATE_WORKOUT_LOADING,
  CREATE_WORKOUT_SUCCESS,
  CREATE_WORKOUT_ERROR,
  UPDATE_WORKOUT_LOADING,
  UPDATE_WORKOUT_SUCCESS,
  UPDATE_WORKOUT_ERROR,
  FETCH_USER_WORKOUTS_WITH_ROUTE_SUCCESS,
} from './constants'

import createReducer from '../createReducer'

export const initialState = {
  error: null,
  workoutSaving: false,
  workoutCopy: null,
  workoutCopyLoading: false,
  userWorkouts: [],
  noUserWorkoutsFound: false,
}

export default createReducer(initialState, {

  [CREATE_WORKOUT_LOADING]: (state) => {
    return { ...state, workoutSaving: true }
  },

  [UPDATE_WORKOUT_LOADING]: (state) => {
    return { ...state, workoutSaving: true, error: null }
  },

  [CREATE_WORKOUT_ERROR]: (state, action) => {
    let error = 'unknown_error'
    const payload = action.payload

    if (payload.response && payload.response.data && payload.response.data._diagnostics) {
      error = 'validation_error'
    }

    return { ...state, workoutSaving: false, error: error }
  },

  [UPDATE_WORKOUT_ERROR]: (state, action) => {
    let error = 'unknown_error'
    const payload = action.payload

    if (payload.response && payload.response.data && payload.response.data._diagnostics) {
      error = 'validation_error'
    }

    return { ...state, workoutSaving: false, error: error }
  },

  [CREATE_WORKOUT_SUCCESS]: (state) => {
    return { ...state, workoutSaving: false }
  },

  [UPDATE_WORKOUT_SUCCESS]: (state) => {
    return { ...state, workoutSaving: false }
  },

  [FETCH_WORKOUT_COPY_LOADING]: (state) => {
    return { ...state, workoutCopyLoading: true }
  },

  [FETCH_WORKOUT_COPY_ERROR]: (state) => {
    return { ...state, workoutCopyLoading: false }
  },

  [FETCH_WORKOUT_COPY_SUCCESS]: (state, action) => {
    const workoutCopy = action.payload.value.data
    return { ...state, workoutCopyLoading: false, workoutCopy }
  },

  [FETCH_USER_WORKOUTS_WITH_ROUTE_SUCCESS]: (state, action) => {
    const userWorkouts = action.payload.map((workout) => workout)
    const noneFound = userWorkouts.length === 0

    return {
      ...state,
      userWorkouts: userWorkouts,
      noUserWorkoutsFound: noneFound,
    }
  },

})
